import { useEffect, useRef, useState } from 'react';
import './../css/Products/Units.css';
import { useScrollReveal } from './../useScrollReveal';
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';
import { useNavigate } from 'react-router-dom';

const Units = ({ productData }) => {
const rowRefs = useRef([]);

  const navigate=useNavigate();

  const sectionRefs = useRef([]);
  const sectionVisibility = useRef([]);
  const [, forceRender] = useState(0);

  const scrollRow = (index, direction) => {
  const row = rowRefs.current[index];
  if (!row) return;

  const cards = row.querySelectorAll('.options-card');
  if (!cards.length) return;

  const currentScroll = row.scrollLeft;

  let targetCard;

  if (direction > 0) {
    targetCard = [...cards].find(
      card => card.offsetLeft > currentScroll + 10
    );
  } else {
    targetCard = [...cards]
      .reverse()
      .find(card => card.offsetLeft < currentScroll - 10);
  }

  if (targetCard) {
    row.scrollTo({
      left: targetCard.offsetLeft,
      behavior: 'smooth',
    });
  }
};

  // Observe ONLY option sections (no hooks inside loops)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index);

          sectionVisibility.current[index] = entry.isIntersecting;

          forceRender((x) => x + 1);
        });
      },
      { threshold: 0.15 }
    );

    sectionRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // single-section animations (correct hook usage)
  const [headerRef, headerVisible] = useScrollReveal();
  const [heroRef, heroVisible] = useScrollReveal();
  const [descRef, descVisible] = useScrollReveal();

  return (
    <div className="main">
        <NavBar/>
      {/* HEADER */}
      <div
        ref={headerRef}
        className={`header reveal ${headerVisible ? 'visible' : ''}`}
      >
        <h3>{productData.header.category}</h3>
        <h1>{productData.header.model}</h1>
        <h4>{productData.header.tagline}</h4>
      </div>

      {/* HERO */}
      <div
        ref={heroRef}
        className={`header-picture reveal ${heroVisible ? 'visible' : ''}`}
      >
        <div>
          <img src={productData.hero.image} alt={productData.header.model} />
          <a href={productData.hero.showroom} target='blank'>{productData.hero.buttonText}</a>
        </div>

        <h1>{productData.hero.title}</h1>
        <p>{productData.hero.description}</p>
      </div>

      {/* DESCRIPTION */}
      <div
        ref={descRef}
        className={`description reveal ${descVisible ? 'visible' : ''}`}
      >
        <div className='description-button'>
          <button
            onClick={() =>
              navigate('/kapcsolat', {
                state: {
                  product_name: productData.header.model,
                },
              })
            }
          >
            Ajánlatkérés
          </button>
        </div>
        <div className="description-title">
          <h2>{productData.description.title}</h2>
        </div>

        <div className="description-details">
          {productData.description.columns.map((column, index) => (
            <div key={index}>
              <ul>
                {column.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="description-picture">
          <img
            src={productData.description.image}
            alt={productData.header.model}
          />
        </div>
      </div>

      {/* OPTIONS */}
      <div className="options">

        {productData.sections.map((section, sectionIndex) => {
          const isVisible = sectionVisibility.current[sectionIndex];

          return (
            <div
              key={sectionIndex}
              data-index={sectionIndex}
              ref={(el) => (sectionRefs.current[sectionIndex] = el)}
              className={`options-rows reveal ${isVisible ? 'visible' : ''}`}
            >
              <h1>{section.title}</h1>

              <div className="options-carousel">
                <button
                  className="carousel-btn prev"
                  onClick={() => scrollRow(sectionIndex, -1)}
                >
                  ❮
                </button>

                <div
                  className="options-row"
                  ref={(el) => (rowRefs.current[sectionIndex] = el)}
                >
                  {section.cards.map((card, cardIndex) => (
                    <div
                      key={cardIndex}
                      className="options-card"
                      style={{
                        transitionDelay: `${cardIndex * 0.12}s`,
                      }}
                    >
                      <div className="options-card-image">
                        <img src={card.image} alt={card.alt} />
                      </div>

                      <div className="options-card-text">
                        <h2>{card.title}</h2>
                        <p>{card.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="carousel-btn next"
                  onClick={() => scrollRow(sectionIndex, 1)}
                >
                  ❯
                </button>
              </div>
            </div>
          );
        })}

      </div>
      <Footer/>
    </div>
  );
}

export default Units